import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import ImpersonationBanner from '../components/ImpersonationBanner'
import PolicyBanner from '../components/PolicyBanner'
import InfoMessage from '../components/InfoMessage'
import AppUpdate from '../components/AppUpdate'
import LeftBar from '../components/LeftBar'
import Loader from '../components/Loader'
import Redirect from '../components/Redirect'
import useAuth from '../hooks/useAuth'

function MainLayout() {
  const { auth, showLoader, showInfo, showUpdate, showPaymentRedirect } = useAuth()
  const [collapsed, setCollapsed] = useState(false)
  const [isImpersonating, setIsImpersonating] = useState(false)
  const toggleSidebar = () => {
    setCollapsed(!collapsed)
  }

  useEffect(() => {
    if (localStorage.getItem("impersonation")) {
      setIsImpersonating(true)
    }
  }, [isImpersonating])

  return (
    <>
      {isImpersonating && (
        <ImpersonationBanner />
      )}
      <div className="relative flex min-h-screen bg-light-purple" style={{ marginTop: isImpersonating ? "54px" : "0", }}>

        <LeftBar collapsed={collapsed} toggleSidebar={toggleSidebar} isImpersonating={isImpersonating} />
        <main className="lg:ml-40 md:p-4 w-full">

          {/* <Header /> */}
          <div className="bg-[#F7F6F9] flex-1 h-full text-[#360F41] rounded-lg px-4 p-6 pb-20 lg:pb-0">
            <Outlet />
          </div>
        </main>

        {collapsed && (
          <div className="absolute bottom-0 mb-4 ml-4">
            <button
              onClick={toggleSidebar}
              className="text-white p-2 rounded-md bg-slate-700 hover:bg-slate-600"
            >
              Open Sidebar
            </button>
          </div>
        )}
        {showLoader && <Loader />}
        {showPaymentRedirect && <Redirect />}
        {showInfo?.message && <InfoMessage />}
        {showUpdate && <AppUpdate />}
        {process.env.REACT_APP_ENV !== 'production' && <PolicyBanner />}
      </div>
    </>
  )
}

export default MainLayout
